// src/utils/breakpoints.js
export const breakpoints = {
    xs: 480,
    s: 675,
    sm: 768,
    md: 1024,
    lg: 1200,
    xl: 1400,
  };
  